<script>
export default {
  components: {},
  props: {
    label: {
      type: String,
      required: true,
    },
    little: {
      type: Boolean,
      required: false,
      default: true,
    },
    btnClass: {
      type: [String, Object],
      required: false,
      default: 'btn-blue',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['click'],
  computed: {},
  methods: {
    click() {
      this.$emit('click');
    },
  },
};
</script>

<template>
  <button
    :disabled="this.disabled"
    :class="[this.btnClass, {disabled: this.disabled, xs: this.little}]"
    type="submit"
    @click="click()">
    <slot name="iconLeft" />
    {{ this.label }}
    <slot name="iconRight" />
  </button>
</template>
